import { render, staticRenderFns } from "./aiReportBI.vue?vue&type=template&id=4ba9fe01&scoped=true"
import script from "./aiReportBI.vue?vue&type=script&lang=js"
export * from "./aiReportBI.vue?vue&type=script&lang=js"
import style0 from "./aiReportBI.vue?vue&type=style&index=0&id=4ba9fe01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba9fe01",
  null
  
)

export default component.exports